import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { LuckyWheelMutationKeys } from '../../../keys'
import { SpinLuckyWheelResponse } from '../../../type'
import { spinLuckyWheel } from '../../services'

export default function useMutationSpinLuckyWheel(
	props?: UseBaseMutationOptions<SpinLuckyWheelResponse>,
) {
	return useMutation({
		mutationKey: [LuckyWheelMutationKeys.SpinLuckyWheel],
		mutationFn: () => spinLuckyWheel(),
		...props,
	})
}
